import {
    fetchA11yStandard as a11yFetchA11yStandard,
} from "../../services/a11yStandardService";
import { DispatchOf } from "../utils";
import { A11yStandardActions } from "../reducers/a11yStandardReducer";
import { CancelToken } from "axios";
import * as types from "../../constants";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchA11yStandard(token: string, cancelToken?: CancelToken) {
    return async (dispatch: DispatchOf<A11yStandardActions> & DispatchOf<ErrorsActions>) => {
        return a11yFetchA11yStandard(token, cancelToken)
            .then((response) => {
                dispatch({
                    type: "FETCH_A11YSTANDARD",
                    payload: response.data
                });
            }).catch((error) => {
                dispatch({
                  type: types.ADD_TOAST,
                  payload: error
                })
          })
    };
}